import { PhonePattern } from './Pattern/Phone';
import { CustomPattern } from './Pattern/CustomPattern';

export class Masked {
  private pattern;

  constructor(mask: string, element: HTMLInputElement) {
    switch (mask) {
      case 'phone':
        this.pattern = new PhonePattern(element);
        break;
      default:
        this.pattern = new CustomPattern(element);
        break;
    }
  }

  public init() {
    this.pattern.init();
  }

  public destroy() {
    this.pattern.destroy();
  }
}
